import { Fragment } from 'preact';
/* @jsx h */
const FilterCheckbox = ({
  option,
  filterName,
  handleChange,
  pluginNamespace,
  isMainSearch,
}) => {
  return (
    <Fragment>
      <input
        id={option.value}
        type="checkbox"
        name={`${pluginNamespace}[filter][]`}
        value={`${filterName}:${option.value}`}
        data-label={`${filterName}-${option.label}`}
        onChange={handleChange}
        checked={option.selected}
        className="sr-only filter__checkbox"
      />
      <label
        htmlFor={option.value}
        className={`btn ${isMainSearch ? 'btn--tertiary' : 'btn--secondary'}`}
      >
        {option.label}
      </label>
    </Fragment>
  );
};

export default FilterCheckbox;
